export { default as PlayStationIcon } from '~icons/mdi/sony-playstation';
